import React from "react";

interface Props {
  score: number;
  zoneLimits: Array<number>
}

const RiskBadge: React.FC<Props> = ({
  score,
  zoneLimits,
}) => {
  let zone = 2;
  let colors = [
    "text-cherry-1000 border-cherry-1000 bg-cherry-500",
    "text-orange-1000 border-orange-1000 bg-orange-500",
    "text-aquamarine-1000 border-aquamarine-1000 bg-aquamarine-500"
  ];
  let texts = ["Critical", "Risk", "Strength"];
  if (score < zoneLimits[0]) {
    zone = 0;
  } else if (score < zoneLimits[1]) {
    zone = 1;
  }

  return (
    <div style={{padding: "2px 8px"}} className={"flex justify-center rounded-full text-xs font-medium border " + (colors[zone])}>
      {texts[zone]}
    </div>
  )
};

export default RiskBadge;
